// extracted by mini-css-extract-plugin
export var aiStarIcon = "_d1-4";
export var closeButton = "_d1-6";
export var dismissButton = "_d1-3";
export var editImageWithAiContainer = "_d1-8";
export var imageUploadWrapper = "_d1-7";
export var misspelledWord = "_d1-5";
export var spellCheckContainer = "_d1-2";
export var spin = "_d1-1";
export var spinning = "_d1-0";